import script from "./MessageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=4eead8aa&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eead8aa"]])

export default __exports__